let idCounter = 0

// Monotonic counter + timestamp - never reset, so ids stay unique across
// game restarts within a session
export const generateId = (prefix = "entity"): string => {
  return `${prefix}-${Date.now()}-${idCounter++}`
}
